module.exports = __webpack_public_path__ + "img/bread_proof.df59c53a.jpg";